import { DISPLAY_SMS_OPTIN_MODAL } from '../constants/actionTypes'
import * as actionTypes from '../constants/actionTypes'
import { ACTION_VALUES } from '../services/analytics'

export const getBaseMsgCode = source => {
  switch (source) {
    case ACTION_VALUES.OPEN_HOUSE:
      return '01'
    case ACTION_VALUES.CONTACT_AGENT:
      return '02'
    default:
      return '00'
  }
}

export const toggleContactModal = source => {
  return {
    type: actionTypes.TOGGLE_CONTACT_MODAL,
    source,
  }
}

export const toggleNewContactModal =
  ({ source, toggleAuthModal, pushOnboardingQueueItem }) =>
  (dispatch, getState) => {
    const {
      user: { logged_in: loggedIn },
    } = getState()
    if (loggedIn) {
      dispatch(toggleContactModal(source))
    } else {
      pushOnboardingQueueItem([dispatch, [toggleContactModal(source)]])
      toggleAuthModal()
    }
  }

export const toggleOptinModal = value => ({
  type: DISPLAY_SMS_OPTIN_MODAL,
  value,
})
